import React, { ComponentPropsWithRef } from 'react'
import { useCommonCtx } from '../context/useCommonCtx'
import { useTranslation } from '../i18n/useTranslation'
import type { TypographyVariant } from '../types/mui'
import { MTypo } from '../components/MTypo/MTypo'

interface Props extends ComponentPropsWithRef<'div'> {
    titleV: TypographyVariant
    bodyV: TypographyVariant
}
export const HowToBuckets = (p: Props) => {
    const { titleV, bodyV } = p
    const t: any = useTranslation(useCommonCtx())

    // FIXME component with other howtos
    return (
        <div className="flex flex-1 shrink-1 flex-col justify-around items-center lg:pb-12">
            {/* mb-12 */}
            <MTypo variant={titleV} className="text-center">
                {t('howto2_title')}
            </MTypo>
            {/* my-8 */}
            {/* FIXME better image */}
            {/* <div className={'border-0 border-black border-solid p-2 my-4'}>
                <img className={`lg:h-full h-48 w-auto object-contain p-1 pointer-events-none`} src={People} />
            </div> */}
            <MTypo
                variant={bodyV}
                outerClassName="mb-2"
                textClassName="text-justify italic lg:text-xl text-base"
            >
                {t('howto2_body')}
            </MTypo>
        </div>
    )
}
